import React from 'react';
import { useParams } from 'react-router-dom';
import SmartSizeWizard from './SmartSizeForm/SmartSizeWizard';

const SmartSizeWizardWrapper = () => {
  const { userId } = useParams();
  const editData = localStorage.getItem('editSmartSize');
  const initialData = editData ? JSON.parse(editData) : null;

  return <SmartSizeWizard userId={userId ? Number(userId) : null} initialData={initialData} />;
};

export default SmartSizeWizardWrapper;
